const storedCarrito = JSON.parse(localStorage.getItem("carrito")) || [];
const initialState = {
  carrito: storedCarrito,
};

const carritoReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_CARRITO":
      //console.log("action.payload", action.payload);
      localStorage.setItem("carrito", JSON.stringify(action.payload));
      return {
        ...state,
        carrito: action.payload,
      };
    case "DELETE_CARRITO":
      localStorage.removeItem("carrito");
      return {
        ...state,
        carrito: [],
      };
    case "ADD_CARRITO": {
      const { id, cantidad } = action.payload;
      let carritoActualizado = [...state.carrito];

      // Verificar si el producto ya está en el carrito
      const index = carritoActualizado.findIndex((item) => item.id === id);

      if (index !== -1) {
        // Si el producto existe, actualizar la cantidad
        carritoActualizado[index].cantidad = cantidad;
      } else {
        // Si no existe, agregarlo como un nuevo objeto
        carritoActualizado.push({ id, cantidad });
      }

      // Guardar en localStorage como JSON
      localStorage.setItem("carrito", JSON.stringify(carritoActualizado));

      return {
        ...state,
        carrito: carritoActualizado,
      };
    }
    default:
      return state;
  }
};

export default carritoReducer;
